import { useEffect, useState } from "react";
import { Navigate } from "react-router-dom";
import AdvancedPremiumServicePage from './AdvancedPremiumServicePage';
import PaymentFailedOverlay from './PaymentFailedOverlay';

const API_BASE_URL =
    window.location.hostname === "staging187611.digassistant.xyz"
        ? "https://api.digassistant.xyz"
        : window.location.hostname === "digassistant.xyz" || window.location.hostname === "www.digassistant.xyz"
            ? "https://api.digassistant.xyz"
            : "http://localhost:8080";

const ProtectedAdvancedServiceRoute = () => {
    const [authData, setAuthData] = useState(null);
    const [loading, setLoading] = useState(true);

    useEffect(() => {
        const checkAuthAndPremium = async () => {
            try {
                const res = await fetch(`${API_BASE_URL}/auth/check`, { credentials: "include" });
                const data = await res.json();
                setAuthData(data);
            } catch (error) {
                setAuthData({ authenticated: false, isPremium: false });
            } finally {
                setLoading(false);
            }
        };
        checkAuthAndPremium();
    }, []);

    const paymentFailed = authData?.paymentFailed === true;
    const hasShownPaymentFailed = localStorage.getItem('paymentFailedShown') === 'true';

    useEffect(() => {
        if (!paymentFailed && hasShownPaymentFailed) {
            localStorage.removeItem('paymentFailedShown');
        }
    }, [paymentFailed, hasShownPaymentFailed]);

    if (loading) {
        return (
            <div style={{ display: 'flex', justifyContent: 'center', alignItems: 'center', height: '100vh', fontSize: '18px', color: '#4CAF50' }}>
                Loading...
            </div>
        );
    }

    if (authData?.verified === false) return <Navigate to="/verify" />;
    if (!authData?.authenticated) return <Navigate to="/login" />;

    // Voyager is a premium feature — free users redirected to the direct URL path
    if (!authData?.isPremium) return <Navigate to="/service" />;

    const showPaymentFailed = paymentFailed && !hasShownPaymentFailed;

    return (
        <>
            <AdvancedPremiumServicePage />
            {showPaymentFailed && <PaymentFailedOverlay />}
        </>
    );
};

export default ProtectedAdvancedServiceRoute;
